import type { FetchFormResponse } from '../../service/types';
import { getScsModerationOutcome } from '../../utils/scs-summary';

export const ScsModerationSummary = ({
  data,
  quarter,
  year,
}: {
  data: FetchFormResponse | undefined;
  quarter: string;
  year: string;
}) => {
  const outcome = getScsModerationOutcome(data, quarter, year);
  if (!outcome) return null;
  return (
    <section aria-label={outcome.title} className="govuk-!-margin-top-4">
      <h4 className="govuk-heading-m">{outcome.title}</h4>
      <dl className="govuk-summary-list">
        <div className="govuk-summary-list__row">
          <dt className="govuk-summary-list__key">Final Marking</dt>
          <dd className="govuk-summary-list__value">{outcome.finalMarking}</dd>
        </div>
        <div className="govuk-summary-list__row">
          <dt className="govuk-summary-list__key">Final Position</dt>
          <dd className="govuk-summary-list__value">{outcome.finalPosition}</dd>
        </div>
      </dl>
    </section>
  );
};
